module.exports = __webpack_public_path__ + "static/img/img-banner1.3929fe3d.gif";